import React, { useRef } from 'react';

const OTPInput = ({ length, onChange, hasError, invalid }) => {
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    const newValues = inputsRef.current.map((input, i) => (i === index ? value : input.value));

    // Move to next input if value is entered
    if (value && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }

    // Move to previous input if value is deleted
    if (!value && index > 0) {
      inputsRef.current[index - 1].focus();
    }

    onChange(newValues.join(''));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !inputsRef.current[index].value && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData('text');
    const pasteValues = paste.slice(0, length).split('');

    pasteValues.forEach((value, i) => {
      inputsRef.current[i].value = value;
    });

    onChange(pasteValues.join(''));

    // Move focus to the next empty input or stay on the last one
    const nextIndex = pasteValues.length < length ? pasteValues.length : length - 1;
    inputsRef.current[nextIndex].focus();
  };

  return (
    <div className='flex items-center gap-x-[12px]'>
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          placeholder='*'
          ref={(el) => (inputsRef.current[index] = el)}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          className={`rounded py-3 px-3 text-center text-sm block w-full focus:border-gray-800 focus:outline-none hover:border-gray-200 hover:bg-gray-50 border bg-gray-100  transition duration-200 focus:bg-white font-outfit placeholder:font-outfit  ${hasError ? 'border-red-600' : 'border-gray-100'}`}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

export default OTPInput;
